import { MarketingTradeEditableFilesProps, MarketingTradeFilesProps } from 'pages/marketing-trade/types';

export const editableFormats = ['.jpg', '.jpeg', '.png', '.svg'];

export const filterEditableFiles = (file: MarketingTradeFilesProps | MarketingTradeEditableFilesProps): boolean => editableFormats.some((format) => file.arquivo.dsLink.endsWith(format));
